<div class="container">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb border-0 p-0">
      <li class="breadcrumb-item" aria-current="page">
        <a class=" text-decoration-none">
          <fa-icon icon="circle-info"></fa-icon>
          <span jhiTranslate="global.menu.infos.main">institutions</span>
        </a>
      </li>
      <li class="breadcrumb-item active text-secondary" aria-current="page">
        Ausbildung
      </li>
    </ol>
  </nav>

  <div class="row mt-4">
    <div class="col-lg-8 mb-3">
      <h4 class="text-primary">Fünf gute Gründe, eine Ausbildung Sexualbegleitung zu machen</h4>
      <ol>
        <li>
          <span class="fw-bold">Profitiere</span> von der steigenden Nachfrage nach Anbieter und Anbieterinnen, welche
          auf
          das Thema Behinderung und
          Sexualität sensibilisiert sind.
        </li>
        <li>
          <span class="fw-bold">Entscheide selbst</span>, welche Art von Behinderungen bei Dir Platz finden. Auch alle
          weiteren Details liegen in deiner
          Hand.
        </li>
        <li>
          <span class="fw-bold">Treffe</span> herzliche und treue Stammkunden, welche mehr suchen als einen billigen
          Quicky.
          Sexcare zählt über 1’000
          registrierte Benutzer mit körperlichem und/oder geistigem Handicap wie auch sexueller Funktionsstörung,
          Demenz,
          Parkinson oder psychischer Einschränkung.
        </li>
        <li>
          <span class="fw-bold">Bekomme</span> echte Anerkennung für deine Arbeit, und erlebe das positive Echo, welches
          sexcare bei Betroffenen, in den
          Medien und bei Experten auslöst.
        </li>
        <li>
          <span class="fw-bold">Nutze</span> unser rundum Paket von der Front für die Front: Workshop – Plattform –
          Betreuung: praxisbezogen,
          professionell, preiswert.
        </li>
      </ol>

      <section class="mt-5">
        <h5 class="mb-3 mt3 text-center text-primary">Erfahrungen von sexcare Sexualbegleiterinnen und
          Sexualbegleiter</h5>
        <ngb-carousel>
          <ng-template ngbSlide>
            <div class="picsum-img-wrapper">
              <div class="card p-3 text-center px-4 shadow-sm">
                <div class="user-image">
                  <img src="../../../content/images/portraitLola.png" class="rounded-circle" width="80">
                </div>
                <div class="user-content">
                  <h5 class="mb-0"> Lola JOY</h5>
                  <p>Sexualbegleiterin</p>
                  <p>
                    <q>Diese Woche habe ich bereits 2 junge Männer, welche unter progressiver Muskeldystrophie leiden,
                      getroffen
                      und es hat alles tiptop geklappt! Sie leben in einem speziellem Wohnheim in Zürich! Bei meinem
                      Besuch
                      dort
                      habe ich auch andere Rolli Fahrer kennengelernt und wir haben uns sehr nett unterhalten! Sie waren
                      mega
                      lieb und süss zu mir und sind sehr dankbar, dass es jetzt durch sexcare.ch eine Möglichkeit für
                      sie gibt
                      Sex zu erleben! Dein Engagement ist also wirklich wichtig und findet unter den Betroffenen grosse
                      Hochachtung! Soviel zu meinen ersten Erfahrungen!</q></p>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template ngbSlide>
            <div class="picsum-img-wrapper">
              <div class="card p-3 text-center px-4 shadow-sm">
                <div class="user-image">
                  <img src="../../../content/images/rollstuhl.png" class="rounded-circle" width="80">
                </div>
                <div class="user-content">
                  <h5 class="mb-0">I.</h5>
                  <p>Consultant / Coach NLP / BA Betriebswirtschaft</p>
                  <p>
                    <q>Die Wertschätzung, die ich von den Herren zu spüren bekomme, bestätigt mich darin, dass dieser
                      Job
                      nichts für Frauen, die verzweifelt dem Cash nachjagen und die Sache einfach hinter sich bringen
                      wollen
                      ist, sondern dass die Sache erst richtig funktioniert, wenn man mit Herz und Seele bereit ist,
                      sich auf
                      den Kunden einzulassen – respektvoll, liebevoll, direkt, unvoreingenommen, ehrlich</q></p>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template ngbSlide>
            <div class="picsum-img-wrapper">
              <div class="card p-3 text-center px-4 shadow-sm">
                <div class="user-image">
                  <img src="../../../content/images/logo-heads.jpg" class="rounded-circle" width="80">
                </div>
                <div class="user-content">
                  <h5 class="mb-0"> U.</h5>
                  <p>Kaufmännische Angestellte</p>
                  <p>
                    <q>„Hallo Isabelle!
                      Der Workshop war einer meiner spannendsten Tage!
                      Schon auf der Heimfahrt kamen die 1. Mails, sie haben mich traurig und stark gemacht und ich
                      denke wir
                      werden gebraucht.“ </q></p>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template ngbSlide>
            <div class="picsum-img-wrapper">
              <div class="card p-3 text-center px-4 shadow-sm">
                <div class="user-image">
                  <img src="../../../content/images/rollstuhl.png" class="rounded-circle" width="80">
                </div>
                <div class="user-content">
                  <h5 class="mb-0"> K.</h5>
                  <p>Fachfrau Betreuung Studentin Germanistik</p>
                  <p>
                    <q>Gebe dir eine kleine Rückmeldung, wie es sich bisher anfühlt auf sexcare.ch.
                      Kurz: Sehr angenehm! Ich investiere die Zeit, den Herren zu antworten, gerne. Es ist eine
                      Auseinandersetzung mit sich selbst, dem Gegenüber, der Sexualität, wirtschaftlichen und
                      ethischen
                      Fragen. Es ist mega spannend, und ich bin sehr gespannt auf die Erfahrungen, die ich mit den
                      Männern
                      machen kann</q></p>
                </div>
              </div>
            </div>
          </ng-template>
        </ngb-carousel>
      </section>
    </div>

    <div class="col-lg-4">
      <div class="border rounded p-3 mb-4" style="background-color: #eaeaea;">
        <h5 class="text-primary">Zertifikat Sexualbegleitung sexcare</h5>
        <div>
          <img
            src="/../../../content/images/Uebergabe-Diplom.jpg"
            alt=""
            class="about-img img-fluid"
          />
        </div>
        <div class="fw-bold">Nächste Daten Schulung</div>
        <p>Sommer 2024</p>
        <div class="fw-bold">Durchführungsort</div>
        <p>Sitz sexcare – xCorp gmbh</p>
        <div class="fw-bold">Unterlagen</div>
        <p>Anfordern unter <a href="mailto:info@sexcare.ch">info&#64;sexcare&#46;ch</a></p>
        <div class="fw-bold">Eindrücke sexcare Workshop’s</div>
        <div>
          <a
            href="https://www.google.com/maps/uv?hl=de&pb=!1s0x478e3532e12ef9d9%3A0xda9162c7512061ba!3m1!7e115!4shttps%3A%2F%2Flh5.googleusercontent.com%2Fp%2FAF1QipPn4h1TaqqdMS0dq0YYhs6Bn0qbi_DbaAM1m2yd%3Dw240-h160-k-no!5ssexcare%20-%20Google-Suche!15sCgIgAQ&imagekey=!1e10!2sAF1QipP3w5HkflnbXR7XQdOpjez9dTyPinf0CJ8wiOUs&sa=X&ved=2ahUKEwiCvNygy4niAhVkQRUIHWcLB6MQoiowDXoECAkQBg">Schloss
            Hünigen Konolfingen</a>
        </div>
        <div><a
          href="https://www.srf.ch/play/tv/popupvideoplayer?starttime=0&urn=urn%3Asrf%3Avideo%3Ac4659015-1d6a-44c6-a89a-96fde5fde18b">
          Paraplegikerzentrum Nottwil</a></div>
        <div class="mt-3">
          <h6>Ihre Ansprechperson</h6>
        </div>
        <div class="align-items-center">
          <div class="w-25 h-25">
            <img
              src="/../../../content/images/ik_logo.png"
              alt=""
              class="about-img img-fluid rounded-circle"
            />
          </div>
          <p>
            Isabelle Kölbl, Geschäftsführerin
            <br>
            <a href="mailto:info@sexcare.ch">info&#64;sexcare&#46;ch</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
